module.exports = __webpack_public_path__ + "static/media/basketball-hoop.b49cb2c9.svg";